import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
export function PromiseSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const promises = [{
    number: '01',
    title: 'Aplicar el método a cualquier tipo de pan',
    description: 'Vas a entender la lógica para adaptarlo a: pan de molde, pan de campo, pizzetas y pizzas grandes, bollitos, y bases que después podés llevar a facturas/medialunas.'
  }, {
    number: '02',
    title: 'Lograr texturas reales',
    description: 'Crocancia por fuera, miga húmeda por dentro, elasticidad sin gluten. Pan que se siente pan.'
  }, {
    number: '03',
    title: 'Dejar de vivir en modo "restricción"',
    description: 'Porque cuando tu cocina tiene soluciones ricas, la ansiedad baja sola. Volvé al ritual del mate, de la mesa familiar, sin culpa.'
  }];
  return <section ref={ref} className="w-full bg-cream px-4 py-16 md:py-24" data-id="element-86">
      <div className="max-w-5xl mx-auto" data-id="element-87">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-88">
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-brown mb-6" data-id="element-89">
            Qué Te Llevás
          </h2>
          <p className="font-body text-lg md:text-xl text-brown/80 max-w-3xl mx-auto" data-id="element-90">
            En mi ebook{' '}
            <span className="font-semibold text-terracotta" data-id="element-91">
              Panadería sin Culpa
            </span>{' '}
            te enseño para que puedas:
          </p>
        </motion.div>

        <div className="space-y-12" data-id="element-92">
          {promises.map((promise, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -30
        }} animate={isInView ? {
          opacity: 1,
          x: 0
        } : {
          opacity: 0,
          x: -30
        }} transition={{
          duration: 0.6,
          delay: 0.2 + index * 0.2
        }} className="flex flex-col md:flex-row gap-6 items-start" data-id="element-93">
              <div className="flex-shrink-0" data-id="element-94">
                <span className="font-heading text-6xl md:text-7xl font-bold text-wheat/30" data-id="element-95">
                  {promise.number}
                </span>
              </div>
              <div className="flex-1" data-id="element-96">
                <h3 className="font-heading text-2xl md:text-3xl font-bold text-brown mb-4" data-id="element-97">
                  {promise.title}
                </h3>
                <p className="font-body text-base md:text-lg text-brown/80 leading-relaxed" data-id="element-98">
                  {promise.description}
                </p>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 20
      }} transition={{
        duration: 0.8,
        delay: 1
      }} className="mt-16 bg-terracotta/10 rounded-2xl p-8 text-center" data-id="element-99">
          <p className="font-body text-lg md:text-xl text-brown font-semibold" data-id="element-100">
            No quiero que dependas de mí para siempre. Quiero que aprendas el
            sistema y lo hagas tuyo.
          </p>
        </motion.div>
      </div>
    </section>;
}